import { Button, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { baseUrl } from "../../Config/baseUrl";

export default function FAQpages() {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const getFAQPages = () => {
    axios
      .get(`${baseUrl}/blog/frontend-page-id-api/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => setData(res.data?.data || []))
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Error fetching FAQ pages");
      });
  };

  useEffect(() => {
    getFAQPages();
  }, []);

  return (
    <div className="p-4 sm:p-0 min-h-screen bg-gray-100">
      <Typography
        variant="h3"
        className="text-center text-blue-900 underline mb-6"
      >
        FAQ Pages
      </Typography>

      {/* Responsive Table */}
      <div className="overflow-x-auto bg-white shadow rounded-lg">
        <table className="min-w-full border border-collapse border-gray-300 table-auto">
          <thead>
            <tr className="bg-gray-100 border-b">
              <th className="px-6 py-2 text-left text-lg font-semibold text-black">
                Name
              </th>
              <th className="px-6 py-2 text-left text-lg font-semibold text-black">
                Path
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item) => (
              <tr
                key={item.id}
                className="border-b hover:bg-gray-50 cursor-pointer transition"
                onClick={() => navigate(`/faq/${item.id}`)}
              >
                <td className="px-6 py-1 overflow-hidden text-lg text-black whitespace-nowrap text-ellipsis">
                  {item.name}
                </td>
                <td className="px-6 py-1 overflow-hidden text-lg text-black whitespace-nowrap text-ellipsis">
                  {item.path}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
